import React, { Component } from "react";
import Vendor from "./Vendor";
import { Product } from "../../Contexts/Contexts";
class Vendors extends Component {
  state = {
    showVendorInfo: false,
    notify: false,
    vendor: {},
  };
  render() {
    const { vendors } = this.context.product;
    const { selectedVariant } = this.context;

    return (
      <div className="vendors">
        <div className="vendorsTitle">
          <h3>لیست فروشندگان</h3>
        </div>
        {vendors
          .filter(
            (v) =>
              v.variant_id === (selectedVariant !== 0 ? selectedVariant : null),
          )
          ?.slice(0, 2)
          .map((vendor) => (
            <Vendor vendor={vendor} />
          ))}
        {/* <InfoPopup
          displayPopup={this.state.showVendorInfo}
          hidePopup={this.handleVendorInfoToast}
          vendor={this.props.selectedVendor ? this.props.selectedVendor : ""}
        /> */}
      </div>
    );
  }
}
Vendors.contextType = Product;
export default Vendors;
